import React, { Component } from 'react';
import { sortDate, formatDate, sliderSettings } from '../../../../utils/utils';
import Slider from 'react-slick';
import ImageLoader from '../../../../components/ImageLoader';
import Truncate from 'react-truncate';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import TableFlagSkeletonLoader from '../../../../components/ui/skeleton/TableFlagSkeletonLoader';
import FlagHeaderLoader from '../../../../components/ui/skeleton/FlagHeaderLoader';

class DashboardFlagsTab extends Component {
  constructor(props) {
    super(props);

    this.flagsTableOptions = {
      onSizePerPageList: this.sizePerPageFlagListChange.bind(this),
      sizePerPage: parseInt(sessionStorage.getItem('flag-table-size')) || 10
    };
  }

  sizePerPageFlagListChange(sizePerPage) {
    sessionStorage.setItem('flag-table-size', sizePerPage);
  }

  render() {
    const options = {
      ...this.flagsTableOptions
    };

    return (
      <div className="square-container-slider">
        <Slider ref={(slider) => (this.slider1 = slider)} {...sliderSettings}>
          {(this.props.podcasts || []).map((p) => (
            <div
              id={
                this.props.decoration && this.props.id == p.id
                  ? 'decoration'
                  : ''
              }
              className="img-slider"
              key={p.id}
              data-toggle="tooltip"
              data-placement="top"
            >
              <ImageLoader
                id={`podcast_${p.id}`}
                src={p.imageUrl}
                width="120px"
                height="120px"
                onClick={() =>
                  this.props.reloadDocumentsAndFlags(
                    0,
                    p.id,
                    p.podcastId,
                    p.name,
                    p.imageUrl,
                    p.feedUrl,
                    p.artistName,
                    p.webPodcast,
                    false,
                    p.authScheme,
                    p.enterpriseType,
                    p.isOwner
                  )
                }
                onLoad={() => this.props.loading}
              />
              <div className="podcast-name">
                <OverlayTrigger
                  trigger={['hover', 'focus']}
                  placement="top"
                  overlay={<Popover id="popover-basic">{p.name}</Popover>}
                >
                  <Truncate lines={2} ellipsis={'...'} width={120}>
                    {p.name}
                  </Truncate>
                </OverlayTrigger>
              </div>
            </div>
          ))}
        </Slider>
        {this.props.loader && (
          <>
            <FlagHeaderLoader />
            <TableFlagSkeletonLoader />
          </>
        )}
        {!this.props.loader && (
          <>
            <div className="square-container-header">
              {this.props.withPodcastId ? (
                <>
                  <div className="img-square-container-header">
                    <ImageLoader src={this.props.podcastImageUrl} />
                  </div>
                  <span style={{ marginLeft: '15px' }}>
                    Your flags for '{this.props.podcastName}'
                  </span>
                </>
              ) : (
                'All your Podcast Flags'
              )}
            </div>
            <div>
              <div
                style={{
                  marginTop: '10px'
                }}
                className="borderTable"
              >
                {this.props.withPodcastId ? (
                  <BootstrapTable
                    pagination
                    search
                    data={
                      this.props.withPodcastId
                        ? this.props.allFlags
                        : this.props.allUserFlags
                    }
                    striped={true}
                    hover={true}
                    options={options}
                    className="epis-flags"
                    expandableRow={this.props.isExpandableRow}
                    expandComponent={this.props.expandComponent}
                    expandColumnOptions={{
                      expandColumnVisible: true,
                      expandColumnComponent: this.props.expandColumnComponent,
                      columnWidth: 50
                    }}
                  >
                    <TableHeaderColumn
                      dataField="id"
                      isKey={true}
                      hidden={true}
                    >
                      ID
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="name"
                      editable={false}
                      tdStyle={{ whiteSpace: 'normal' }}
                      dataSort={true}
                    >
                      Document Name
                    </TableHeaderColumn>
                    <TableHeaderColumn dataField="tagId" hidden={true}>
                      TagID
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="tag"
                      editable={false}
                      dataSort={true}
                    >
                      Tag
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="date"
                      editable={false}
                      dataSort={true}
                      sortFunc={sortDate}
                      dataFormat={formatDate}
                    >
                      Date
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="dictation"
                      tdStyle={{ whiteSpace: 'normal' }}
                      dataAlign="left"
                      paddingLeft="0px"
                      dataFormat={(cell) => (
                        <div style={{ whiteSpace: 'pre-line' }}>{cell}</div>
                      )}
                    >
                      Dictation
                    </TableHeaderColumn>
                  </BootstrapTable>
                ) : (
                  <BootstrapTable
                    pagination
                    search
                    data={
                      this.props.withPodcastId
                        ? this.props.allFlags
                        : this.props.allUserFlags
                    }
                    striped={true}
                    hover={true}
                    options={this.props.options}
                    className="epis-flags"
                    expandableRow={this.props.isExpandableRow}
                    expandComponent={this.props.expandComponent}
                    expandColumnOptions={{
                      expandColumnVisible: true,
                      expandColumnComponent: this.props.expandColumnComponent,
                      columnWidth: 50
                    }}
                  >
                    <TableHeaderColumn
                      dataField="id"
                      isKey={true}
                      hidden={true}
                    >
                      ID
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="podcastName"
                      editable={false}
                      tdStyle={{ whiteSpace: 'normal' }}
                      dataSort={true}
                    >
                      Podcast Name
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="name"
                      editable={false}
                      tdStyle={{ whiteSpace: 'normal' }}
                      dataSort={true}
                    >
                      Document Name
                    </TableHeaderColumn>
                    <TableHeaderColumn dataField="tagId" hidden={true}>
                      TagID
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="tag"
                      editable={false}
                      dataSort={true}
                    >
                      Tag
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="date"
                      editable={false}
                      dataSort={true}
                      sortFunc={sortDate}
                      dataFormat={formatDate}
                    >
                      Date
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="dictation"
                      tdStyle={{ whiteSpace: 'normal' }}
                      dataAlign="left"
                      paddingLeft="0px"
                      dataFormat={(cell) => (
                        <div style={{ whiteSpace: 'pre-line' }}>{cell}</div>
                      )}
                    >
                      Dictation
                    </TableHeaderColumn>
                  </BootstrapTable>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}

export default DashboardFlagsTab;
